<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow: auto; height: calc(100vh - 179px)">
            <es-org-tree @clickByOrg="()=>{this.queryObj.pageNum = 1;init()}" :isAll="1" @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="7">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-fenlei el-icon--left"></i>模版名称
          </div>
          <div class="es-op-box">
            <el-input placeholder="请输入模版名"
                      v-model="queryObj.keyWord"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="()=>{this.queryObj.pageNum = 1;init()}">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right:6px"
                       @click="add_init">新增</el-button>
            <es-delete @del="del()"
                       type="button"></es-delete>
          </div>
          <el-table :data="pageData.list"
                    ref="templateTable"
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loading"
                    style="cursor: pointer;"
                    @row-click="choose">
            <el-table-column type="selection"
                             width="40"
                             align="center">
            </el-table-column>
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="name"
                             label="巡检模版">
            </el-table-column>
            <el-table-column prop="orgName"
                             label="所属组织">
            </el-table-column>
            <el-table-column label="操作"
                             width="80"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="编辑"
                         @click="edit_init(scope.row)"
                         type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="del(scope.row.id)"
                           :key="scope.row.id"
                           type="icon"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadTemplateList()}">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-fenlei el-icon--left"></i>选择巡检项【{{currentTemplate.name}}】
          </div>
          <div class="es-op-box">
            <el-input placeholder="巡检项名称"
                      v-model="queryObjItem.label"
                      size="small"
                      class="query"
                      style="float: left;margin-bottom:6px"
                      clearable
                      @change="
                () => {
                  this.queryObjItem.pageNum = 1
                  this.loaditemdetailList()
                  
                }
              ">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>

            <el-input placeholder="对象类型"
                      v-model="queryObjItem.typeIdName"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="
                () => {
                  this.queryObjItem.pageNum = 1
                  this.loaditemdetailList()
                  
                }
              ">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>

            <el-select v-model="queryObjItem.instypeId"
                       style="float: left"
                       size="small"
                       class="query"
                       clearable
                       placeholder="请选择巡检类别"
                       @change="() => {
                        this.queryObjItem.pageNum = 1
                  this.loaditemdetailList()                  
                }">
              <el-option v-for="item in instype"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
          <el-table :data="itemdetailPageData.list"
                    ref="itemdetailTable"
                    border
                    stripe
                    size="mini"
                    highlight-current-row
                    height="calc(100vh - 250px)"
                    @select-all="handleSelectionChange"
                    v-loading="loadingItemdetail">
            <el-table-column width="40"
                             type="selection"
                             align="center">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.checked"
                             @change="changeItem(scope.row)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="instypeName"
                             label="巡检类别">
            </el-table-column>
            <el-table-column prop="typeIdName"
                             label="对象类型">
            </el-table-column>
            <el-table-column prop="sysName"
                             label="所属系统">
              <template slot-scope="scope">
                <span v-if="scope.row.instypeId == 1"></span>
                <span v-if="scope.row.instypeId == 2">{{scope.row.sysName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="label"
                             label="巡检项名称">
            </el-table-column>
            <el-table-column prop="type"
                             label="字段类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">文本框</span>
                <span v-if="scope.row.type == 2">下拉框</span>
                <span v-if="scope.row.type == 3">文本域</span>
              </template>
            </el-table-column>
            <el-table-column prop="dictFatherName"
                             label="字典表名称">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 2 ">{{scope.row.dictFatherName}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="itemdetailPageData"
                           @change="(cpage)=>{this.queryObjItem.pageNum=cpage;this.loaditemdetailList()}">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑模版-->
    <el-dialog :visible.sync="editVisible"
               @closed="()=>this.$refs['templateForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑巡检模版
      </span>
      <el-form :model="templateInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="templateForm">
        <el-form-item prop="name"
                      label="巡检模版">
          <el-input v-model="templateInfo.name"
                    placeholder="请输入巡检模版"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="orgId" label="所属组织">
          <el-cascader ref="orgId" v-model="templateInfo.orgId" :show-all-levels="false"
            :props="{ value: 'id', checkStrictly: true }" :options="orgTree" filterable style="width: 200px">
          </el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submit()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'instemplate',
  props: ["funcs"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      queryObjItem: { pageNum: 1, pageSize: 20, label: "" },//查询条件
      instype: [
        { value: 1, label: "设备巡检" },
        { value: 2, label: "区域巡检" }
      ],
      orgTree: [],
      pageData: {},
      itemdetailPageData: {},
      editVisible: false,
      templateInfo: {},//模版信息
      rules: {//验证条件
        name: [
          { required: true, message: '请输入巡检模版', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ],
        orgId: [{ required: true, message: "请选择所属部门", trigger: "blur" }],
      },
      loading: false,
      saving: false,
      loadingItemdetail: false,
      currentTemplate: { id: null, name: null }

    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadTemplateList()

    },
    //从后台查询巡检模版列表
    loadTemplateList () {
      this.loading = true
      this.$ajax.get('/buss/instemplate/list', this.queryObj).then(msg => {
        this.pageData = msg
        if (msg.list != null && msg.list.length > 0) {
          this.currentTemplate = { id: msg.list[0].id, name: msg.list[0].name }
          this.loaditemdetailList()
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    initOrgTree (orgTree) {
      this.orgTree = orgTree;
    },
    //初始化添加巡检模版
    add_init () {
      this.editVisible = true
      this.templateInfo = {}
    },
    //初始化编辑巡检模版
    edit_init (row) {
      this.editVisible = true
      this.templateInfo = JSON.parse(JSON.stringify(row))
    },
    //保存巡检模版
    submit () {
      this.$refs["templateForm"].validate(valid => {
        this.templateInfo.orgId = this.$refs.orgId.getCheckedNodes()[0].value;
        this.templateInfo.orgName = this.$refs.orgId.getCheckedNodes()[0].label;
        if (valid) {
          let url = "/buss/instemplate/add";
          if (this.templateInfo.id != null) {
            url = "/buss/instemplate/edit";
          }
          this.saving = true
          this.$ajax.post(url, this.templateInfo).then(msg => {
            this.saving = false
            this.loadTemplateList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除巡检模版
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["templateTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/instemplate/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadTemplateList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },
    //加载所有的巡检项
    loaditemdetailList () {
      this.loadingItemdetail = true
      this.queryObjItem.orderBy = "type_id,instype_id,type_id,label+0"
      this.$ajax.get('/buss/item/detaillist', this.queryObjItem).then(msg => {
        this.itemdetailPageData = msg
        this.loadTemplateItemList()
        this.loadingItemdetail = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingItemdetail = false
      })
    },
    loadTemplateItemList () {
      this.$ajax.get('/buss/instemplate/itemlist', { templateId: this.currentTemplate.id }).then(msg => {
        this.itemdetailPageData.list.forEach(item => {
          this.$set(item, 'checked', false)
          for (let i = 0; i < msg.length; i++) {
            if (msg[i].itemId == item.id) {
              this.$set(item, 'checked', true)
              break
            }
          }
        })

      }).catch(err => {
        this.$message.error(err)
      })
    },
    choose (item) {
      this.currentTemplate = { id: item.id, name: item.name }
      this.queryObjItem = { pageNum: 1, pageSize: 20, label: "" }
      this.loaditemdetailList()
    },
    changeItem (item) {
      if (item.checked == true) {
        //添加
        this.$ajax.post("/buss/instemplate/addtemplateitem", { templateId: this.currentTemplate.id, itemId: item.id }).then(msg => {
          this.$message.success(msg)
        }).catch(err => {
          this.$message.error(err)
        })
      } else {
        //删除
        this.$ajax.post("/buss/instemplate/deletetemplateitem", { templateId: this.currentTemplate.id, itemId: item.id }).then(msg => {
          this.$message.success(msg)
        }).catch(err => {
          this.$message.error(err)
        })
      }
    },
    handleSelectionChange (val) {
      if (val.length > 0) {
        val.forEach((item) => {
          this.itemdetailPageData.list.forEach((e) => {
            if (item.id == e.id && e.checked == false) {
              e.checked = true
              this.$ajax.post("/buss/instemplate/addtemplateitem", { templateId: this.currentTemplate.id, itemId: item.id }).then(msg => {
                console.log(msg)
              }).catch(err => {
                this.$message.error(err)
              })
            }
          });
        });
        this.$message.success("添加模版巡检项成功")
      } else {
        this.itemdetailPageData.list.forEach((e) => {
          if (e.checked == true) {
            e.checked = false
            this.$ajax.post("/buss/instemplate/deletetemplateitem", { templateId: this.currentTemplate.id, itemId: e.id }).then(msg => {
              console.log(msg)
            }).catch(err => {
              this.$message.error(err)
              return
            })
          }
        });
        this.$message.success("删除模版巡检项成功")
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
